import React from 'react';
import { PropTypes } from 'prop-types';
import StatusText from './StatusText';
import getStatusConfig from './statuses';
import { useFeasibility } from 'hooks/useFeasibility';

const Status = ({ className, order }) => {
  const { getIsOrderNonCore } = useFeasibility();
  const statusConfig = getStatusConfig(order, getIsOrderNonCore(order));

  return (
    <div className={className} data-testid="shipment-card-status">
      {!!statusConfig?.subTitle && (
        <StatusText subTitle={statusConfig.subTitle} />
      )}
    </div>
  );
};

Status.propTypes = {
  className: PropTypes.string,
  order: PropTypes.shape({
    id: PropTypes.number.isRequired,
  }),
};

Status.defaultProps = {
  order: {},
};
export default Status;
